import Connect from "./Connect/Connect";
import AddMailboxAccount from "./AddMailboxAccount/AddMailboxAccount";
import { types } from "./types";
import RemoveFromUserMailGroup from "./RemoveFromUserMailGroup/RemoveFromUserMailGroup";
import DisableMailbox from "./DisableMailbox/DisableMailbox"
import DeleteMailbox from "./DeleteMailbox/DeleteMailbox";
import ChangeMailboxSize from "./ChangeMailboxSize/ChangeMailboxSize";
import AddUserToMailGroup from "./AddUserToMailGroup/AddUserToMailGroup";
import RunScript from "./RunScript/RunScript";

//Enter the switch according to the incoming action names, it renders.
function Actions(
  action,
  showAlert,
  variables,
  setOpenVariable,
  variableRender
) {
  switch (action.actionName) {
    case types.CONNECT:
      return (
        <Connect
          action={action}
          showAlert={showAlert}
          variables={variables}
          setOpenVariable={setOpenVariable}
        />
      );
    case types.ADDMAILBOXACCOUNT:
      return (
        <AddMailboxAccount
          action={action}
          showAlert={showAlert}
          variables={variables}
          setOpenVariable={setOpenVariable}
        />
      );
    case types.REMOVEFROMUSERMAILGROUP:
      return (
        <RemoveFromUserMailGroup
          action={action}
          showAlert={showAlert}
          variables={variables}
          setOpenVariable={setOpenVariable}
        />
      );
    case types.DISABLEMAILBOX:
      return (
        <DisableMailbox
          action={action}
          showAlert={showAlert}
          variables={variables}
          setOpenVariable={setOpenVariable}
        />
      );
    case types.DELETEMAILBOX:
      return (
        <DeleteMailbox
          action={action}
          showAlert={showAlert}
          variables={variables}
          setOpenVariable={setOpenVariable}
        />
      );
    case types.CHANGEMAILBOXSIZE:
      return (
        <ChangeMailboxSize
          action={action}
          showAlert={showAlert}
          variables={variables}
          setOpenVariable={setOpenVariable}
        />
      );
    case types.ADDUSERTOMAILGROUP:
      return (
        <AddUserToMailGroup
          action={action}
          showAlert={showAlert}
          variables={variables}
          setOpenVariable={setOpenVariable}
        />
      );
    case types.RUNSCRIPT:
      return (
        <RunScript
          action={action}
          showAlert={showAlert}
          variables={variables}
          setOpenVariable={setOpenVariable}
        />
      );
    default: break;
  }
}

export default Actions;
